import { useEffect, useState } from 'react';
import { B2B_ENRICHMENT } from '../workspace/constants/endpoints';

export function useCheckIsB2BEnrichment() {
  const [isEnrichment, setIsEnrichment] = useState(false);

  useEffect(() => {
    const currentUrl = window.location.href;

    if (currentUrl.includes(B2B_ENRICHMENT)) {
      setIsEnrichment(true);
    }
  }, [window.location.href]);

  return isEnrichment;
}
